import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/logo_golden_white.png';
import '../styles/KioskMode.css';

interface FamilyMember {
  individualID: number;
  clientID: string;
  name: string;
  relationship: string;
}

interface LocationState {
  clientName?: string;
  clientId?: string;
  familyId?: number;
  familyMembers?: FamilyMember[];
  householdName?: string;
}

export function KioskSuccessPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as LocationState | null;
  const [countdown, setCountdown] = useState(30);

  // Auto-redirect after 30 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/kiosk');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleNewIntake = () => {
    navigate('/kiosk');
  };

  return (
    <div className="kiosk-success-page">
      <img src={logo} alt="Belafonte TACOLCY Center" style={{ maxHeight: 80, marginBottom: '1rem' }} />

      <div className="kiosk-success-icon">
        <span role="img" aria-label="checkmark">&#x2714;</span>
      </div>

      <h1 className="kiosk-success-title">Thank You!</h1>

      <p className="kiosk-success-message">
        Your information has been submitted successfully.
        A staff member will be with you shortly.
      </p>

      {state?.clientName && (
        <div className="kiosk-success-details">
          {state.householdName ? (
            <>
              <p style={{ fontSize: '1.2rem', marginBottom: '0.5rem', color: 'white' }}>
                <strong>{state.householdName}</strong>
              </p>
              <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.95rem' }}>
                {(state.familyMembers?.length || 0) + 1} family members registered
              </p>
              <div style={{
                marginTop: '1rem',
                padding: '1rem',
                background: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '8px',
                textAlign: 'left'
              }}>
                <p style={{ margin: '0 0 0.5rem 0', color: '#333' }}>
                  <strong style={{ color: '#5B2C86' }}>{state.clientName}</strong>
                  <span style={{ color: '#666', marginLeft: '0.5rem', fontSize: '0.9rem' }}>(Head of Household)</span>
                </p>
                {state.familyMembers?.map((member, index) => (
                  <p key={index} style={{ margin: '0.25rem 0', color: '#333' }}>
                    <strong style={{ color: '#5B2C86' }}>{member.name}</strong>
                    <span style={{ color: '#666', marginLeft: '0.5rem', fontSize: '0.9rem' }}>({member.relationship})</span>
                  </p>
                ))}
              </div>
            </>
          ) : (
            <>
              <p style={{ color: 'white' }}><strong>Name:</strong> {state.clientName}</p>
              {state.clientId && <p style={{ color: 'rgba(255,255,255,0.9)' }}><strong>Client ID:</strong> {state.clientId}</p>}
            </>
          )}
        </div>
      )}

      <button
        className="kiosk-button kiosk-button-gold"
        onClick={handleNewIntake}
        style={{ minWidth: 200 }}
      >
        Start New Intake
      </button>

      <p className="kiosk-countdown">
        This screen will reset in {countdown} seconds
      </p>
    </div>
  );
}
